export const getNftColor = (numberOfNfts: number) => {
  if (numberOfNfts >= 10) {
    return '#F4C818'
  }

  if (numberOfNfts >= 5) {
    return '#FD2C76'
  }

  return '#41A9F2'
}
